import axios from 'axios';

import { uiActions } from '../ui-slice';
import { form2Actions } from './form2-slice';

import { GET_QUOTES_URL } from '../../constants/constants';
import { doNavigation } from '../../utils/helper-functions';

export const form2Transaction = (
  token,
  keyGS,
  postalCode,
  typeVehicle,
  brand,
  subbrand,
  model,
  version,
  currentStep,
  navigateHook,
) => {
  const formData = {
    tipoValor: 'comercial',
    claveGs: keyGS,
    prefijo: typeVehicle === 'auto' ? 'AR' : 'PP',
    cp: postalCode,
    modelo: model,
    numeroDias: 14,
  };

  return async (dispatch) => {
    dispatch(uiActions.setLoaderStatus({ type: 'simple' }));
    axios
      .post(
        GET_QUOTES_URL,
        formData,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      .then((res) => {
        if (res.data.status === 'error') {
          throw new Error(res.data.message);
        } else {
          const responseData = res
            && res.data
            && res.data.data
            && res.data.data.planes;
          if (responseData) {
            dispatch(form2Actions.setForm2TransactionData({
              typeVehicle,
              typeVehiclePrefix: formData.prefijo,
              brand,
              subbrand,
              model,
              version,
              versionKeyGS: keyGS,
              planes: responseData,
            }));
            doNavigation(currentStep, 'forward', navigateHook, dispatch, true);
          } else {
            throw new Error('No se obtubieron las cotizaciones correctamente.');
          }
        }
      })
      .catch((err) => {
        let errMsg = '';
        if (err.message !== '' && !err.message.includes('Request')) {
          errMsg = err.message;
        }
        dispatch(uiActions.setErrorStatus({
          type: 'generic',
          title: 'Ha ocurrido un error',
          body: errMsg || 'Hubo un error al obtener tu cotización',
        }));
        throw err;
      });
  };
};
